<template>
  <transition name="slide">
    <div class="deploymentStatus">
      <oButton @click="closeWindow" class="job-window-close" icon="fa fa-window-close" />
      <h3>Deployment status:</h3>
      <ul class="joblist">
        <li v-for="deployment in deploymentInfo" :key="deployment.id">
          <p>CorrelationId: <span>{{deployment.correlationId}}</span></p>
          <p v-show="deployment.runId">RunId: <span>{{deployment.runId}}</span></p>
          <p v-show="deployment.connectionString">ConnectionString: <span class="connection-string">{{deployment.connectionString}}</span></p>
          <p v-show="deployment.connectionString">Direct link: <a href="https://hcmexternaldownload.blob.core.windows.net/hcmdownload/HybridConnectionManager.msi">Hybrid Connection Manager <svg class="fa fa-download"></svg></a></p>
          <p>Status:
            <span class="pill-status" :class="stylestatus(deployment.status)">
              {{deployment.status}}
            </span>
          </p>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import oButton from './oButton'

export default {
  name: 'DeploymentStatus',
  components: {
    oButton,
  },
  props: ['deploymentInfo'],
  data() {
    return {}
  },
  methods: {
    stylestatus(s) {
      if (s == 'Failed') {
        return 'fail'
      } else if (s == 'Suspended' || s == 'Canceled') {
        return 'suspended'
      } else if (s == 'Processing'|| s == 'Running') {
        return 'process'
      } else {
        return 'success'
      }
    },
    closeWindow(e) {
      this.$emit('closeWindow', e)
    },
  },
}
</script>


<style scoped>
.deploymentStatus {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 130px;
  z-index: 1000;
  right: 2%;
  max-width: 330px;
  padding: 10px;
  background-color: var(--o-bg1);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
h3 {
    font-weight: 400;
    color: var(--o-text);
 }
.joblist {
  list-style: none;
  margin: 0;
  padding: 0;
}
.joblist li {
  border: 1px solid grey;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 5px;
}
.joblist li a{
    color: var(--o-primary);
    padding: 5px;
    text-decoration: none;
    border: 1px solid transparent;
  }
.joblist li a:hover{border: 1px solid var(--o-primary);}
.joblist li p {
  font-weight: 400;
  color: var(--o-text);
}
.joblist li span {
  font-weight: normal;
  color: var(--o-text-on-bg1);
}
.pill-status {
  color: var(--o-text-on-bg) !important;
  padding: 5px;
  font-weight: bold !important;
}
.connection-string{
  word-wrap: break-word;
}
.success {
  background-color: var(--o-success);
}
.fail {
  background-color: var(--o-error);
}
.process {
  background-color: var(--o-processing);
}
.suspended {
  background-color: var(--o-suspended);
}
.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  opacity: 0;
  transform: translateX(30px);
}
.slide-leave-to {
  opacity: 0;
}

/* ================================= 
  Media Queries
==================================== */

@media (min-width: 769px) {
  .deploymentStatus {
    right: 10%;
    max-width: 376px;
  }
}
@media (min-width: 1025px) {
  .deploymentStatus {
    right: 10%;
    max-width: 376px;
  }
}
</style>